import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import i18n from "./i18n"; // Import the i18n configuration
import { I18nextProvider } from "react-i18next";
import { ThemeProvider } from "./components/ui/theme-provider";
import App from "./App";
import "./index.css";
import "./satoshi.css";
import "./fonts.css";
import "leaflet/dist/leaflet.css";

// Auto-unregister service workers in development to prevent Workbox logs
import "./utils/unregisterSW.js";

// Polyfill BarcodeDetector on browsers that lack it (notably iOS Safari and
// Firefox). Uses ZXing-cpp via WASM, ~10x faster than pure-JS jsQR for QR
// codes — close to native iOS Camera performance for dense/distant codes.
// Native implementations (Chrome, Edge) are left alone.
if (typeof window !== "undefined" && !("BarcodeDetector" in window)) {
	import("barcode-detector/ponyfill")
		.then(({ BarcodeDetector }) => {
			window.BarcodeDetector = BarcodeDetector;
		})
		.catch((err) => {
			console.warn("BarcodeDetector polyfill failed to load:", err);
		});
}

ReactDOM.createRoot(document.getElementById("root")).render(
	// <React.StrictMode> // Commented out to prevent double API calls in development
	<ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
		<I18nextProvider i18n={i18n}>
			<BrowserRouter>
				<App />
			</BrowserRouter>
		</I18nextProvider>
	</ThemeProvider>
	// </React.StrictMode>
);
